//App.js

import './App.css';
import React from 'react';
import Github from './components/Github';
import Spotify from './components/Spotify';
import GalleryNexmind from './components/gallery/GalleryNexmind';
import GalleryMorifarm from './components/gallery/GalleryMorifarm';
import GalleryTechtrove from './components/gallery/GalleryTechtrove';
import { HashRouter, Routes, Route } from 'react-router-dom';
import RootLayout from './layouts/RootLayout';
import Homepage from './layouts/Homepage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<RootLayout />}>
          <Route index element={<Homepage />} />
          <Route path="github" element={<Github />} />
          <Route path="spotify" element={<Spotify />} />
          <Route path="gallery-nexmind" element={<GalleryNexmind />} />
          <Route path="gallery-morifarm" element={<GalleryMorifarm />} />
          <Route path="gallery-techtrove" element={<GalleryTechtrove />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;